<div class="grid grid-cols-12 gap-(--spacing-layout-l)">
  <!-- Personalised Dashboard tab content -->
</div>
